<template>
  <div>
    <div class="weui-cells__title">
      实名认证 - 支持 jpg/png/gif<span style="color: red">（不能超过4M）</span>
    </div>
    <div class="weui-cells weui-cells_form" id="uploader">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <div class="weui-uploader">
            <div class="weui-uploader__hd">
              <p class="weui-uploader__title">请上传学生证照片</p>
              <div class="weui-uploader__info">
                <span id="uploadCount">0</span>/1
              </div>
            </div>
            <div class="weui-uploader__bd">
              <ul class="weui-uploader__files" id="uploaderFiles"></ul>
              <div class="weui-uploader__input-box">
                <input
                  id="uploaderInput"
                  class="weui-uploader__input"
                  type="file"
                  accept="image/*"
                  multiple=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="warehousing-footer-item sureinwarehousing"
      style="flex: 2"
      @click="save"
    >
      <a href="javascript:;">提 交</a>
    </div>
  </div>
</template>
<script>
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      studentCardInfo: {},
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
  },
  methods: {
    save() {
      let that = this;
      if (!this.studentCardInfo.destFileName) {
        weui.alert("请上传图片");
        return false;
      } else {
        let studentCardUrl = `${config.xytPreUrl}/sign/${this.studentCardInfo.dateFolder}/${this.studentCardInfo.destFileName}`;
        axios
          .put("/api/user/updateStudentCardUrl", {
            studentCardUrl: studentCardUrl,
          })
          .then((res) => {
            if (res.data.success) {
              weui.toast("保存成功", 1000);
              // 跳转回个人中心页面
              that.$router.push("/userInfo/" + that.encodeToken);
            } else {
              weui.alert("保存失败");
            }
          })
          .catch((err) => {
            weui.alert("保存失败");
          });
      }
    },
  },
  mounted() {
    let that = this;
    /* 图片自动上传 */
    var uploadCount = 0,
      uploadList = [];
    var uploadCountDom = document.getElementById("uploadCount");
    weui.uploader("#uploader", {
      url: "/api/upload/uploadFile",
      auto: true,
      type: "file",
      fileVal: "fileVal",
      compress: {
        width: 1600,
        height: 1600,
        quality: 0.8,
      },
      onBeforeQueued: function (files) {
        if (
          ["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(
            this.type
          ) < 0
        ) {
          weui.alert("请上传正确格式的图片");
          return false;
        }
        if (this.size > 4 * 1024 * 1024) {
          weui.alert("请上传不超过4M的图片");
          return false;
        }
        if (files.length > 1) {
          // 防止一下子选中过多文件
          weui.alert("最多只能上传1张图片");
          return false;
        }
        if (uploadCount + 1 > 1) {
          weui.alert("最多只能上传1张图片");
          return false;
        }

        ++uploadCount;
        uploadCountDom.innerHTML = uploadCount;
      },
      onQueued: function () {
        uploadList.push(this);
      },
      onBeforeSend: function (data, headers) {
        headers["Authorization"] = "Bearer " + that.token;
        // return false; // 阻止文件上传
      },
      onProgress: function (procent) {},
      onSuccess: function (ret) {
        that.studentCardInfo = ret.data;
      },
      onError: function (err) {
        console.log(err);
      },
    });

    // 缩略图预览
    document
      .querySelector("#uploaderFiles")
      .addEventListener("click", function (e) {
        var target = e.target;

        while (!target.classList.contains("weui-uploader__file") && target) {
          target = target.parentNode;
        }
        if (!target) return;

        var url = target.getAttribute("style") || "";
        var id = target.getAttribute("data-id");

        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
        }
        var gallery = weui.gallery(url, {
          className: "custom-name",
          onDelete: function () {
            weui.confirm("确定删除该图片？", function () {
              --uploadCount;
              uploadCountDom.innerHTML = uploadCount;
              that.studentCardInfo = {};

              for (var i = 0, len = uploadList.length; i < len; ++i) {
                var file = uploadList[i];
                if (file.id == id) {
                  file.stop();
                  break;
                }
              }
              target.remove();
              gallery.hide();
            });
          },
        });
      });
  },
};
</script>

<style scoped>
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/userinfos/StudentCardEdit.vue